import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import 'dayjs/locale/ko';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import SearchCard, { fieldProps } from '../common/list/SearchCard';
import FilterToggleGroup from '../common/list/FilterToggleGroup';

const prjTypOptions = [
  { id: 0, value: 'all', label: '전체', color: null },
  { id: 1, value: 'N', label: '프로젝트', color: 'info' },
  { id: 2, value: 'M', label: '유지보수', color: 'success' },
];

// 포캐스팅 통계(/forecastmonthstat) 검색 영역 - 중요도 필터 없음(2026-10-23, "중요도별
// 통계" → "포캐스팅 통계" 전환). 다른 목록 화면과 같은 SearchCard/FilterToggleGroup
// 레이아웃을 쓴다(fc30533 설계). 엑셀 다운로드 버튼은 카드 바깥(컨테이너)에서 그린다.
export const SearchBox = ({ formik }) => {
  const [searchStrtDt, setSearchStrtDt] = useState(null);
  const [searchEndDt, setSearchEndDt] = useState(null);

  useEffect(() => {
    if (formik.values.searchStrtDt !== null) {
      setSearchStrtDt(dayjs(formik.values.searchStrtDt));
    }
    if (formik.values.searchEndDt !== null) {
      setSearchEndDt(dayjs(formik.values.searchEndDt));
    }
  }, [formik.values.searchStrtDt, formik.values.searchEndDt]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  const handleFilterType = (value) => formik.setFieldValue('searchPrjTyp', value);

  return (
    <SearchCard
      onSubmit={formik.handleSubmit}
      submitting={formik.isSubmitting}
      gridSx={{
        gridTemplateAreas: {
          xs: `"type" "period" "btns"`,
          sm: `"type period btns"`,
        },
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'auto minmax(280px, 1fr) auto',
        },
      }}
    >
      {/* 전체/프로젝트/유지보수 */}
      <Box sx={{ gridArea: 'type', minWidth: 0, display: 'flex', alignItems: 'center' }}>
        <FilterToggleGroup
          label="타입"
          options={prjTypOptions}
          value={formik.values.searchPrjTyp}
          onChange={handleFilterType}
        />
      </Box>

      {/* 매출 시작~종료일 */}
      <Box sx={{ gridArea: 'period', minWidth: 0 }}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0 }}>
            <DatePicker
              label="매출 시작일"
              format="YYYY-MM-DD"
              mask={'____-__-__'}
              id="searchStrtDt"
              name="searchStrtDt"
              value={searchStrtDt}
              onChange={(newValue) => {
                setSearchStrtDt(dayjs(newValue));
                onChangeDate(dayjs(newValue), 'searchStrtDt');
              }}
              slotProps={{
                textField: {
                  ...fieldProps,
                  sx: { minWidth: 0, flex: '1 1 140px' },
                  error: formik.touched.searchStrtDt && Boolean(formik.errors.searchStrtDt),
                  helperText: formik.touched.searchStrtDt && formik.errors.searchStrtDt,
                },
              }}
            />
            <Typography variant="body2" color="text.secondary" sx={{ flexShrink: 0 }}>
              ~
            </Typography>
            <DatePicker
              label="매출 종료일"
              format="YYYY-MM-DD"
              mask={'____-__-__'}
              id="searchEndDt"
              name="searchEndDt"
              value={searchEndDt}
              onChange={(newValue) => {
                setSearchEndDt(dayjs(newValue));
                onChangeDate(dayjs(newValue), 'searchEndDt');
              }}
              slotProps={{
                textField: {
                  ...fieldProps,
                  sx: { minWidth: 0, flex: '1 1 140px' },
                  error: formik.touched.searchEndDt && Boolean(formik.errors.searchEndDt),
                  helperText: formik.touched.searchEndDt && formik.errors.searchEndDt,
                },
              }}
            />
          </Box>
        </LocalizationProvider>
      </Box>
    </SearchCard>
  );
};
